import { IApplicationState } from '../../types/redux';

export const selectTotal = (state: IApplicationState) => {
  return state.offersData.total;
};
